import { BlocksTableRow } from 'blocks-nextjs/blocks-web-components/components/table-row/table-row';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';
export const CatTableRow = createComponent({ react: React, tagName: 'cat-table-row', elementClass: BlocksTableRow });
